import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ComponentsModule } from '@client/app/components/components.module';
import { ReadabilityComponent } from './changes-history/dashboard/summary/readability/readability.component';
import { PerformanceComponent } from './changes-history/dashboard/summary/performance/performance.component';
import { ChangeHistoryComponent } from './changes-history/dashboard/tables/change-history/change-history.component';
import { SeoComponent } from './changes-history/dashboard/tables/seo/seo.component';
import { PolicyComponent } from './changes-history/dashboard/tables/policy/policy.component';
import { QaComponent } from './changes-history/dashboard/tables/qa/qa.component';
import { AccessibilityComponent } from './changes-history/dashboard/tables/accessibility/accessibility.component';
import { ReadabilityTableComponent } from './changes-history/dashboard/tables/readability/readability.component';
import { DataPrivacyComponent } from './changes-history/dashboard/tables/data-privacy/data-privacy.component';
import { PerformanceComponent as PerformanceTableComponent } from './changes-history/dashboard/tables/performance/performance.component';
import { ChangesHistoryDashboardComponent } from './changes-history/dashboard/changes-history-dashboard.component';
import { ChangesHistoryComponent } from './changes-history/changes-history.component';
import { GlobalPolicyDistributionComponent } from './policy/policy/distribution/distribution.component';
import { GlobalPolicyMatchesComponent } from './policy/policy/matches/matches.component';
import { GlobalPolicyPriorityComponent } from './policy/policy/priority/priority.component';
import { GlobalPolicyTypesComponent } from './policy/policy/types/types.component';
import { GlobalPolicyPoliciesComponent } from './policy/policies/policies.component';
import { GlobalPolicyDialogsTargetsComponent } from './policy/dialogs/targets/targets.component';
import { GlobalPolicyDashboardComponent } from './policy/global-policy-dashboard.component';
import { PagesUsersComponent } from './users/users.component';
import { UpgradePipeModule } from '@client/app/filters/upgrade-pipe.module';
import { TranslateModule } from '@client/app/modules/translate.module';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { BubbleComponent } from '@client/app/modules/charts/components/bubble.component';
import { TablePolicyTypeComponent } from '@monsido/modules/table-policy-type/table-policy-type.component';
import { MonActionMenuModule } from '@client/ng2/shared/components/action-menu/action-menu.module';
import { BarComponent } from '@client/app/modules/charts/components/bar.component';
import {
    LayoutModule,
    MonDatePickerModule,
    MonEventTriggerModule,
    MonTableSortModule,
} from '@monsido/angular-shared-components';
import { LineComponent } from '@client/app/modules/charts/components/line.component';
import { ExportModule } from '@client/app/modules/export/export.module';
import { UsersModule } from '@client/app/pages/admin/users/users.module';
import { NgCsvDirective } from '@client/app/directives/ng-csv.directive';
import { DatePickerComponent } from '@client/app/components/date-picker/date-picker.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ComponentsModule,
        UpgradePipeModule,
        TranslateModule,
        NgbTooltipModule,
        BubbleComponent,
        TablePolicyTypeComponent,
        MonActionMenuModule,
        BarComponent,
        LayoutModule,
        LineComponent,
        MonEventTriggerModule,
        MonDatePickerModule,
        MonTableSortModule,
        ExportModule,
        UsersModule,
        NgCsvDirective,
        DatePickerComponent,
    ],
    exports: [],
    declarations: [
        ReadabilityComponent,
        PerformanceComponent,
        ChangeHistoryComponent,
        SeoComponent,
        PolicyComponent,
        QaComponent,
        AccessibilityComponent,
        ReadabilityTableComponent,
        DataPrivacyComponent,
        PerformanceTableComponent,
        ChangesHistoryDashboardComponent,
        ChangesHistoryComponent,
        GlobalPolicyDistributionComponent,
        GlobalPolicyMatchesComponent,
        GlobalPolicyPriorityComponent,
        GlobalPolicyTypesComponent,
        GlobalPolicyPoliciesComponent,
        GlobalPolicyDialogsTargetsComponent,
        GlobalPolicyDashboardComponent,
        PagesUsersComponent,
    ],
    providers: [],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class UpgradeGlobalModule {}
